"use client";

import React from "react";
import { ContactForm } from "@/components/molecules/contact-form";
import { ArrowLeftIcon } from "@heroicons/react/24/outline";
import HeadsetIcon from "@/components/atoms/dynamic-icons/headset";
import EnvelopeIcon from "@/components/atoms/dynamic-icons/envelope";
import WhatsappIcon from "@/components/atoms/dynamic-icons/whatsapp";
import InstaIcon from "@/components/atoms/dynamic-icons/insta";
import LinkedinIcon from "@/components/atoms/dynamic-icons/linkedin";
import { useRouter } from "next/navigation";

export default function ContactPage() {
  const router = useRouter();

  return (
    <div className='bg-bg-base min-h-screen px-6 py-12 md:px-12 lg:px-24'>
      {/* Back Button */}
      <button
        onClick={() => router.back()}
        className='text-text-title hover:text-link-primary mb-10 flex items-center gap-2 text-sm font-medium transition-colors md:text-base'
      >
        <ArrowLeftIcon className='size-4 stroke-[2.5px]' /> Back
      </button>

      <div className='mx-auto max-w-7xl'>
        <div className='grid grid-cols-1 gap-16 lg:grid-cols-2'>
          {/* Left Column: Information */}
          <div className='space-y-10'>
            <div className='space-y-4'>
              <div className='bg-link-primary/10 flex size-16 items-center justify-center rounded-2xl'>
                <HeadsetIcon className='text-link-primary size-8' />
              </div>
              <h1 className='text-text-title text-4xl font-bold tracking-tight md:text-5xl lg:text-6xl'>Contact Us</h1>
              <p className='text-text-title/70 max-w-lg text-lg leading-relaxed md:text-xl'>
                We&apos;re here to help. Fill out the form below and we&apos;ll get back to you shortly.
              </p>
            </div>

            {/* Contact Details */}
            <div className='space-y-6 pt-6'>
              <div className='flex items-start gap-4'>
                <div className='bg-text-title/5 mt-1 flex size-10 items-center justify-center rounded-full'>
                  <EnvelopeIcon className='text-text-title/80 size-5' />
                </div>
                <div>
                  <h3 className='text-text-title font-semibold'>Email Support</h3>
                  <p className='text-text-title/60'>support@onyx.com</p>
                </div>
              </div>

              <div className='flex items-start gap-4'>
                <div className='bg-text-title/5 mt-1 flex size-10 items-center justify-center rounded-full'>
                  <WhatsappIcon className='text-text-title/80 size-5' />
                </div>
                <div>
                  <h3 className='text-text-title font-semibold'>WhatsApp</h3>
                  <p className='text-text-title/60'>+234 123 456 7890</p>
                </div>
              </div>
            </div>

            {/* Socials */}
            <div className='space-y-4'>
              <h3 className='text-text-title text-sm font-bold tracking-wider uppercase'>Follow Us</h3>
              <div className='flex gap-4'>
                <a
                  href='#'
                  className='bg-text-title/5 hover:bg-link-primary flex size-12 items-center justify-center rounded-xl transition-all hover:text-white'
                >
                  <InstaIcon className='size-6' />
                </a>
                <a
                  href='#'
                  className='bg-text-title/5 hover:bg-link-primary flex size-12 items-center justify-center rounded-xl transition-all hover:text-white'
                >
                  <LinkedinIcon className='size-6' />
                </a>
              </div>
            </div>

            {/* Decorative Element */}
            <div className='from-link-primary/20 relative hidden h-64 w-full overflow-hidden rounded-3xl bg-gradient-to-br to-transparent lg:block'>
              <div className='bg-link-primary/10 absolute -top-20 -right-20 size-80 rounded-full blur-3xl'></div>
              <div className='absolute -bottom-10 left-10 size-40 rounded-full bg-blue-400/10 blur-2xl'></div>
              <div className='flex h-full items-center justify-center p-8'>
                <p className='text-text-title/40 text-center font-medium italic'>
                  &quot;Connecting you to the credit you deserve.&quot;
                </p>
              </div>
            </div>
          </div>

          {/* Right Column: Form */}
          <div className='relative'>
            <div className='from-link-primary/20 to-link-primary/10 absolute -inset-1 rounded-[2.5rem] bg-gradient-to-tr via-transparent blur-2xl'></div>
            <div className='border-text-title/10 relative rounded-[2rem] border bg-white p-8 shadow-2xl md:p-12 dark:bg-[#0A0A0A]'>
              <ContactForm />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
